export const api: Record<string, string> = {
  'https://jobtracker.deved.dev': 'https://jobtracker-backend.deved.dev',
  'https://jobtracker.deved.nl': 'https://jobtracker-backend.deved.nl',
  'https://jobtracker.agros.nl': 'https://jobtracker.agros.nl/backend',
  'http://localhost:5173': 'http://localhost:8080',
  'http://localhost:5174': 'http://localhost:8080',
  'http://localhost:5175': 'http://localhost:8080',
  'http://localhost:8080': 'http://localhost:8080',
};
